import api from '@/plugins/kitsu';
import requireAuth from './interceptors/deviceAuth';

const device = api('current_device_service', {
    middleware: [requireAuth],
});

export default Object.freeze({
  getCurrentDevice: (params = {}) =>
    device.get('current-device', {
      ...params,
    }),

  setCurrentDeviceLanguage: (language) =>
    device.axios.request({
      url: 'current-device',
      method: 'patch',
      data: { data: { type: 'current-devices', attributes: {defaultLocale: language}}},
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    }),
});
